import {
  mapState
} from "vuex";
export default {

  computed: {
    
  },
  data() {
    return {
      approvalTitle: {
        // 印章
        'key_0': '使用/外带印章审批',
        'key_1': '新增/销毁印章审批',

        // 工程项目
        'key_2': '项目申请审批',
        'key_4': '招标控制价审批',
        'key_4_3': '预算（招标控制价）审批',
        'key_5': '付款审核意见单',
        // 'key_6': '项目进度款支付',
        // 'key_8': '项目结算款支付',
        'key_10': '招标文件会签',
        'key_11': '合同会签/备案',
        'key_13': '修改预警时间审批',
        'key_14': '款项支付审批表',

        // 合同相关
        'key_30': '招标文件会签',
        'key_31': '合同会签/备案',
        'key_33': '付款审核意见单',
        'key_32': '款项支付审批表',

        // 独立支付
        'key_40': '款项支付审批表',

        // 仓库
        'key_50': '仓库材料领用审批',
        'key_51': '仓库材料退库审批',

        // 易耗品
        'key_60': '易耗品申购单',
        'key_61': '易耗品采购计划审批',
        'key_62': '易耗品入库审批',
        'key_63': '易耗品领用审批',
        'key_64': '易耗品退库审批',

        // 采购
        'key_70': '采购申请审批',
        'key_71': '采购备案审批',

        // 其他
        'key_100': '通用业务审批',
        // 请假
        'key_101': '请假/休假审批',
        // 人员调动
        'key_102': '人员调动审批',
        // 考勤未签到说明
        'key_104': '考勤未签到说明',

        // 车辆
        'key_80': '商务用车申请',
        'key_81': '生产经营保障用车申请',
        'key_82': '子公司用车申请',
        'key_83': '子公司修车申请',
        'key_84': '生产经营保障用车派遣申请',
        'key_85': '租用车辆派遣申请',
        'key_86': '作业车辆调度申请',
        'key_87': '车辆维修申请',
        'key_88': '车辆维修验收',
        'key_89': '车辆管理奖惩申请',
        'key_90': '车辆购置申请',
        'key_91': '原水车辆维修申请',

        // 固定资产
        'key_110': '固定资产处置审批',
        'key_111': '固定资产调拨审批',


        'key_103': '废弃项目/合同',

        'key_120': '供应商准入申请',

        'key_130': '会议/会议室使用申请',

      }
    }
  },
  methods: {
    
  },
  watch: {

  }
}


// WEBPACK FOOTER //
// ./src/Mixins/approvalType.js